module.exports = __webpack_public_path__ + "files/a3d0c31ac91c284b7ad97aafef238bd0.png";